import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";

import HeaderM from "../../Invs/maintaince/A4/HeaderM";
import LoadingPage from "../../../services/LoadingPage";

import * as _ from "lodash";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { ButtonBase, Grid, Typography } from "@material-ui/core";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import { sto } from "../../../Context/InshData";
import HeaderCashier from "./HeaderCashier";
import BodyCashier from "./BodyCashier";
import FooterCashier from "./FooterCashier";

function BillPage(props) {
    // const { locInv, found, sta, inv, chunk } = props;
    const { locInv, found, sta, inv, chunk, isFirst, isLast, sum, onUnmountComplete } = props;
    const clas = useInvAF();
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

    const style = {
        width: "85mm",
        backgroundColor: "#fff",
    };
    const stylle = {
        width: "85mm",
        backgroundColor: "#fff",
    };
    return (
        <Grid item container justifyContent='center' >
            <Fragment>
                <HeaderCashier info={found} locInv={locInv} />
                <BodyCashier
                    sta={sta}
                    locInv={locInv}
                    premiApp={premiApp}

                />
                <FooterCashier
                    inv={inv}
                    locInv={locInv}
                    found={found}
                />
            </Fragment>
        </Grid>
    );
}
function RevCashairCon(props) {
    const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
    const [found, setFound] = useState({});
    const [sta, setSta] = useState({});
    const [inv, setInv] = useState({});
    const [loading, setLoading] = useState(true);
    const [chunks, setChunks] = useState([]);

    let count_id = 0;
    const getInfo = async () => {
        const tb = {
            GetFoundation: true,
            Rpt_Inv: true,
            wait: true,
            SettInvsApp:true,
            parms: {
                lprocid: locInv.proc_id,
                ibranchid: sto.branchi,
                branch: sto.branchi,
                iFoundid: 1,
                sProcTypeInvProc: locInv.ProcTypeInvProc,
            },
            autos: {},
        };
        console.log(tb);
        await axios
            .post(`${uri}Res`, tb)
            .then((res) => {
                setSta({ info: res.data.RptInv, tot: res.data.infoBill ,StngIA:res.data.SettInvsApp});
                console.log("res.data.RptInv");
                const data2 = res.data.RptInv.map((row, i) => {
                    return {
                        ...row,
                        no: i + 1,
                    };
                });
                setChunks(_.chunk(data2, 200));
                setFound(res.data.Found);
            })
            .catch((error) => {
                console.log("catch");
            });
    };
    const getInv = async () => {
        axios
            .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
            .then((res) => {
                console.log("the inve for fatoora", res.data);
                setInv(res.data);
            })
            .catch((error) => { });
    };
    useEffect(() => {
        setTimeout(async () => {
            await getInfo();
            await getInv();
            setLoading(false);
            //onUnmountComplete();
        }, 0);
    }, []);

    if (!found || !sta || loading) return <LoadingPage />;


    return (
        <Typography component="div" justifyContent='center' >
                {chunks.map((page, i) => {
                    return (
                        <BillPage
                            {...{
                                locInv,
                                found,
                                sta,
                                inv,
                                chunk: page,
                                isFirst: i == 0,
                                isLast: i == chunks.length - 1,
                            }}
                        />
                    );
                })}
        </Typography>
    );
}
export default RevCashairCon;
